import * as yup from 'yup'
export interface CustomerPolicyModel {
    customerPolicyId: number,
    masterPolicyTypeId: number,
    policyStatus: string,
    policyNumber: string,
    isProcessed: boolean,
    userId: number,
    stateId?: number
}




export const CustomerPolicyModel_VS =
    yup.object().shape({
     
    });

